import { render, staticRenderFns } from "./Synergy.vue?vue&type=template&id=05c739a3&"
import script from "./Synergy.vue?vue&type=script&lang=js&"
export * from "./Synergy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports